import { render, staticRenderFns } from "./ProgramsConfig.vue?vue&type=template&id=3295e803&"
import script from "./ProgramsConfig.vue?vue&type=script&lang=js&"
export * from "./ProgramsConfig.vue?vue&type=script&lang=js&"
import style0 from "./ProgramsConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports